import React from "react";
import { useBnbSelector } from "../../../redux/store";
import { BnbLabel, useBnbOptionalLabel } from "../../../utils/labels";
import * as Flex from "../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import Container from "../../../../../../common-deprecated/styles/v2/lexus/globals/Container";
import * as Type from "../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { isRTL } from "../../../../../../common-deprecated/settings/utils/commonSettingUtils";
import DisclaimerContainer from "../common/disclaimer/DisclaimerContainer";
import FinanceToggle from "../common/FinanceToggle";
import GradeItem from "./GradeItem";

const SelectGrade = (): JSX.Element => {
    const bodyType = useBnbSelector((state) => state.navigation.bodyType);
    const gradeInfo = useBnbSelector((state) => state.grades);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const availablePromotions = useBnbSelector((state) => state.items.promotions);
    const genericPriceDisclaimerGrades = useBnbOptionalLabel("genericPriceDisclaimerGrades");

    return (
        <>
            <Container my={{ _: 5, md: "60px" }}>
                <Flex.Row mb={6}>
                    <Flex.Col
                        width={{ xs: 1, md: 1 / 2, lg: 8 / 12 }}
                        textAlign={isRTL(commonSettings) ? "right" : "left"}
                    >
                        <Type.H1 headingType="gamma">
                            <BnbLabel label="selectGrade" />
                        </Type.H1>
                    </Flex.Col>

                    <Flex.Col
                        display="flex"
                        justifyContent="flex-end"
                        width={{ xs: 1, md: 1 / 2, lg: 4 / 12 }}
                        textAlign={{ xs: "left", md: "right" }}
                        px={{ md: 3 }}
                        pt={{ xs: 3, md: 0 }}
                    >
                        <FinanceToggle modelCode={gradeInfo.modelCode} />
                    </Flex.Col>
                </Flex.Row>

                {gradeInfo.list.map((grade) => (
                    <GradeItem
                        key={grade.id}
                        commonSettings={commonSettings}
                        gradeInfo={gradeInfo}
                        grade={grade}
                        bodyType={bodyType}
                        availablePromotions={availablePromotions}
                        genericPriceDisclaimerGrades={genericPriceDisclaimerGrades}
                    />
                ))}
            </Container>
            <Container>
                <DisclaimerContainer showGenericFinanceDisclaimer hasDarkBackground />
            </Container>
        </>
    );
};

export default SelectGrade;
